import { useMutation, useQueryClient } from '@tanstack/react-query'
import { OtpProviderService } from '@/modules/otp-provider/api/services'
import { OTP_PROVIDER_QUERY_KEYS } from '@/modules/otp-provider/constants'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import type { paths } from '@/schema'

type CreateOtpProviderBody =
	paths['/api/admin/otp-provider']['post']['requestBody']['content']['application/json']
type CreateOtpProviderResponse =
	paths['/api/admin/otp-provider']['post']['responses']['201']['content']['application/json']

const useMutationCreateOtpProvider = () => {
	const queryClient = useQueryClient()

	return useMutation<CreateOtpProviderResponse, Error, CreateOtpProviderBody>({
		mutationFn: (body) => OtpProviderService.createOtpProvider(body),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: OTP_PROVIDER_QUERY_KEYS.PROVIDERS.ALL,
			})
			toast.success('สร้างผู้ให้บริการ OTP สำเร็จ')
		},
		onError: (error) => {
			showErrorToast(error)
		},
	})
}

export default useMutationCreateOtpProvider
